import LayoutHR from "layouts/layout-hr";
import React from "react";
import StatisticsCards from "./components/StatisticsCards";
import AttendanceGraphChart from "./components/AttendanceGraphChart";
import PriceByAssetGroupChart from "./components/PriceByAssetGroupChart";
import AssetTrendsChart from "./components/AssetTrendsChart";

const HrHomePage = () => {
  return (
    <LayoutHR>
      <div className="container-xl">
        {/* Page Header */}
        <div className="page-header d-print-none">
          <div className="row align-items-center">
            <div className="col">
              <h2 className="page-title">HR Dashboard</h2>
              <div className="text-muted mt-1">
                Human Resources Management Overview
              </div>
            </div>
          </div>
        </div>

        {/* Statistics Cards */}
        <StatisticsCards />

        {/* Attendance Graph Section */}
        <div className="row row-deck row-cards mb-4">
          <AttendanceGraphChart />
        </div>

        {/* Asset Statistics Section */}
        <div className="row row-deck row-cards">
          <PriceByAssetGroupChart />
          <AssetTrendsChart />
        </div>
      </div>
    </LayoutHR>
  );
};

export default HrHomePage;